//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkDependency } from '@/datalayer/helpers/attributes';

export default {
  props: {
    attribute: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    values: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    initialResults() {
      return this.attribute.type_options?.initial_results || 5;
    },
    options() {
      let options = [...this.attribute.type_options?.options] || [];

      options = options.filter((o) => checkDependency(o.dependency, this.values));
      // options.sort((a, b) => a.name.localeCompare(b.name));

      if (!this.showAll) {
        return options.slice(0, this.initialResults);
      }

      return options;
    },
    hasMore() {
      const options = this.attribute.type_options?.options || [];

      return (options.length > this.initialResults);
    },
  },
  methods: {
    toggleMore() {
      this.showAll = !this.showAll;
    },
    select(event) {
      this.$emit('input', event);
    },
  },
};
